import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const state = {
    checkoutList: [],
    lastQuery: null,
};

const getters = {
    checkoutList: state => {
        return state.checkoutList;
    },
};

const mutations = {
    setCheckoutList(state, data) {
        state.checkoutList = data;
    },

    setLastQuery(state, query) {
        state.lastQuery = query;
    },
};

const actions = {
    findCheckouts({ commit, dispatch }, params) {
        let options = {
            params: params,
        };

        let checkouts = state.checkoutList.filter(c => {
            return params.ids.includes(c.id);
        });

        if (checkouts.length === params.ids.length) {
            return Promise.resolve(checkouts);
        }

        startLoading(dispatch, 'find-checkouts');

        return axios
            .get(Laroute.route('franchise.vue.checkouts'), options)
            .then(res => {
                endLoading(dispatch, 'find-checkouts');
                return res.data.data;
            })
            .catch(err => {
                endLoading(dispatch, 'find-checkouts');
                throw err;
            });
    },

    getCheckout({ commit, dispatch }, id) {
        let checkout = state.checkoutList.find(d => d.id === id);

        if (checkout !== undefined) {
            return Promise.resolve(checkout);
        }

        return axios
            .get(Laroute.route('franchise.checkout.show', { id: id }))
            .then(res => res.data.data);
    },

    getCheckoutListIfNecessary({ commit, dispatch }, params = {}) {
        if (!state.checkoutList.length || state.lastQuery !== params.query) {
            dispatch('getCheckoutList', params);
        }
    },

    getCheckoutList({ commit, dispatch }, params) {
        let options = {
            params: _.merge(
                {
                    limit: 10,
                },
                params,
            ),
        };

        startLoading(dispatch, 'fetch-checkout');

        return axios
            .get(Laroute.route('franchise.vue.checkouts'), options)
            .then(res => {
                let data = res.data.data;

                commit('setCheckoutList', data);
                commit('setLastQuery', params.query);
                endLoading(dispatch, 'fetch-checkout');

                return data;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-checkout');
                throw err;
            });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/checkout.js